import React, { useRef, useState } from 'react';
import { TextField } from '@mui/material';
import textfieldStyle from "../../GlobalStyles/styles";
import styles from '../ProjectNumPopUp/ProjectNumPopUp.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';
import { useSnackbar } from 'notistack';
import { useDispatch } from '../../redux/store';
import { downloadAllProjectsLogbook, downloadProjectLogbook } from '../../redux/slices/exports';

const ProjectLogbookPopUp = ({ isVisible, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [projectNumber, setProjectNumber] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const promiseRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!projectNumber) {
      enqueueSnackbar('Please enter a project number', { variant: 'warning' });
      return;
    }
    setSubmitting(true);
    try {
      promiseRef.current?.abort?.();
      promiseRef.current = dispatch(downloadProjectLogbook({ projectNumber }));
      await promiseRef.current.unwrap();
      enqueueSnackbar('Download started', { variant: 'success' });
      onClose();
    } catch (err) {
      console.error('Error downloading project logbook:', err);
      enqueueSnackbar(err?.message || 'Unexpected error downloading logbook', { variant: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDownloadAll = async () => {
    setSubmitting(true);
    try {
      promiseRef.current?.abort?.();
      promiseRef.current = dispatch(downloadAllProjectsLogbook());
      await promiseRef.current.unwrap();
      enqueueSnackbar('Download started', { variant: 'success' });
      onClose();
    } catch (err) {
      console.error('Error downloading project logbook (all):', err);
      enqueueSnackbar(err?.message || 'Unexpected error downloading logbook', { variant: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} style={{ width: '520px' }} onClick={e => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <p className={styles.text} style={{ fontWeight: 'bold' }}>
            Enter a project number to download the CSV logbook for that project.
          </p>

          <div className={styles.inputSection} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label className='FilterLabel' htmlFor="logbookProjectNumber" style={{ fontSize: '13px', whiteSpace: 'nowrap', marginBottom: '5px' }}>
              Project Number:
            </label>
            <TextField
              id="logbookProjectNumber"
              sx={textfieldStyle}
              type="number"
              value={projectNumber}
              onChange={(e) => setProjectNumber(e.target.value)}
              fullWidth
              disabled={submitting}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
            <div style={{ width: '110px', height: '25px' }}>
              <button type="submit" className={buttonStyles.YesButtonComponentStyling} disabled={submitting}>
                {submitting ? 'Downloading...' : 'DOWNLOAD'}
              </button>
            </div>
            <div style={{ width: '140px', height: '25px', marginLeft: '10px' }}>
              <button type="button" className={buttonStyles.YesButtonComponentStyling} onClick={handleDownloadAll} disabled={submitting}>
                {submitting ? 'Downloading...' : 'DOWNLOAD ALL'}
              </button>
            </div>
            <div style={{ width: '90px', height: '25px', marginLeft: '10px' }}>
              <button type="button" className={buttonStyles.NoButtonComponentStyling} onClick={onClose} disabled={submitting}>
                CANCEL
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectLogbookPopUp;


